// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"3f5bc6fd","513":"8f4b39f9","703":"7c04868e","787":"7cd27494"}[chunkId] + ".chunk.js";
};